export const GROUP_INDEXING_RULE_LIST_SUCCESS = 'GROUP_INDEXING_RULE_LIST_SUCCESS';
export const CREATE_GROUP_INDEXING_RULE_SUCCESS = 'CREATE_GROUP_INDEXING_RULE_SUCCESS';
export const UPDATE_GROUP_INDEXING_RULE_SUCCESS = 'UPDATE_GROUP_INDEXING_RULE_SUCCESS';
export const REMOVE_GROUP_INDEXING_RULE_SUCCESS = 'REMOVE_GROUP_INDEXING_RULE_SUCCESS';
